import { Select } from "../../../styles";
import { allMonth, allYear } from "../../../utils/data";

const FilterReport = ({ month, year, setMonth, setYear }) => {
      return (
            <div className="d-flex justify-content-end gap-2 my-3">
                  <Select
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                        name="month"
                        className="w-auto"
                  >
                        <option value="">Select Month</option>
                        {
                              allMonth.map((month, i) =>
                                    <option value={month} key={i}>{month}</option>
                              )
                        }
                  </Select>
                  <Select
                        value={year}
                        onChange={(e) => setYear(e.target.value)}
                        name="year"
                        className="w-auto"
                  >
                        <option value="">Select Year</option>
                        {
                              allYear.map((year, i) =>
                                    <option value={year} key={i}>{year}</option>
                              )
                        }
                  </Select>

            </div>
      );
};

export default FilterReport;